const bulkAddQuestionnaireItemsPath = '/questionnaire-items/bulk-add';
export default bulkAddQuestionnaireItemsPath;
